import { render, staticRenderFns } from "./channel-home.vue?vue&type=template&id=f2be780c&scoped=true"
import script from "./channel-home.vue?vue&type=script&lang=js"
export * from "./channel-home.vue?vue&type=script&lang=js"
import style0 from "./channel-home.vue?vue&type=style&index=0&id=f2be780c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2be780c",
  null
  
)

export default component.exports